import type { HowItWorksStep } from "../types/step.types";

export const STEPS: HowItWorksStep[] = [
  {
    id: "01",
    title: "Tell us your story",
    description:
      "Start by sharing a bit about yourself through our secure onboarding process. Whether you are dealing with anxiety, relationship struggles, or just seeking personal growth, this helps us understand your unique needs and emotional state.",
    tagline: "A safe space from the very first click.",
    imageColor: "bg-gradient-to-br from-[#122332] via-[#1D4263] to-[#155A7D]",
    imageUrl:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "02",
    title: "Find your perfect match",
    description:
      "Using the information you shared, our intelligent matching system connects you with licensed therapists and counsellors whose expertise aligns perfectly with your specific concerns, preferred language, and cultural background.",
    tagline: "Therapy works best when you truly connect.",
    imageColor: "bg-gradient-to-br from-[#155A7D] via-[#1F6E95] to-[#2B83AF]",
    imageUrl:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "03",
    title: "Begin your healing journey",
    description:
      "Connect with your healer on your terms. Choose between secure chat-first text sessions, audio calls, or video sessions based on your comfort level. Your privacy is protected with enterprise-grade encryption at every step.",
    tagline: "Healing at your own pace, in your own way.",
    imageColor: "bg-gradient-to-br from-[#2B83AF] via-[#3B96C3] to-[#4FADD7]",
    imageUrl:
      "https://images.unsplash.com/photo-1544027993-37dbfe43562a?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "04",
    title: "Grow with continuous support",
    description:
      "Therapy is not just about a single session; it's a journey. Access your personalized dashboard to track your progress, book follow-up sessions, and switch healers anytime without any hassle if your needs change.",
    tagline: "We are here for you, for the long haul.",
    imageColor: "bg-gradient-to-br from-[#3D8CB3] via-[#4FADD7] to-[#7DE2F8]",
    imageUrl:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=800&q=80",
  },
];

export const MARQUEE_ROW_1 = [
  "Stress & Anxiety",
  "Overthinking",
  "Relationship Issues",
  "Depression",
  "Self-discovery",
  "Grief & Loss",
  "Burnout",
  "Career Pressure",
  "Family Conflicts",
];

export const MARQUEE_ROW_2 = [
  "Life Transitions",
  "Trauma Healing",
  "Low Self-Esteem",
  "Sleep Issues",
  "Anger Management",
  "Phobias",
  "Mindfulness",
  "Personal Growth",
  "Loneliness",
];
